import {config} from "../config.js";

export class HttpService {
    static api = config.api;
    static async get(url) {
        if (!url) return null;
        try {
            const response = await fetch(this.api + url);

            if (!response.ok) {
                console.error(`HTTP ошибка! Статут: ${response.status}`);
            }
            return await response.json();
        } catch (error) {
            console.error(`Не удалось получить данные из "${url}":`, error);
            throw error; // Пробрасываем ошибку для обработки в вызывающем коде
        }
    }
}